module.exports = __webpack_public_path__ + "static/media/icon-piggy-bank-active.ce2c2fe2.svg";